import { render, staticRenderFns } from "./WorkEditor.vue?vue&type=template&id=6f8ff111&scoped=true"
import script from "./WorkEditor.vue?vue&type=script&lang=js"
export * from "./WorkEditor.vue?vue&type=script&lang=js"
import style0 from "./WorkEditor.vue?vue&type=style&index=0&id=6f8ff111&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8ff111",
  null
  
)

export default component.exports